import { render, staticRenderFns } from "./DodPanelRoles.vue?vue&type=template&id=5b720fce&scoped=true&"
import script from "./DodPanelRoles.vue?vue&type=script&lang=js&"
export * from "./DodPanelRoles.vue?vue&type=script&lang=js&"
import style0 from "./DodPanelRoles.vue?vue&type=style&index=0&id=5b720fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b720fce",
  null
  
)

export default component.exports